export const extractInteriorColor = (requestText: string): string => {
  const color = requestText.match(/^[^,]+/);
  return color ? color[0] : '';
};
